import React from "react";
import { ApiSubscriptionPlan } from "src/api/types";

interface SubscriptionGridProps {
	children?: any;
	selected?: ApiSubscriptionPlan;
	columns: number;
}

const SubscriptionGrid = ({
	children,
	selected,
	columns,
}: SubscriptionGridProps) => {
	return (
		<div
			className={`grid  w-full mx-auto transition-all ${
				selected?.slug
					? "grid-cols-2 max-w-[1080px]"
					: columns === 2
					? "md:grid-cols-1 lg:grid-cols-2 flex-1"
					: "md:grid-cols-1 lg:grid-cols-3 flex-1"
			}`}
		>
			{children}
		</div>
	);
};

export default SubscriptionGrid;
